<div style="flex: auto; display: flex">
       <div style="flex: auto;">
        <span class="header">{{ $ctrl.item.name }}</span></br>
        <span class="path">{{ $ctrl.item.path }}</span>
    </div>
    <span ng-if="$ctrl.item.isEditable" ng-click="$ctrl.removeItem()" style="flex: 0 1 11px;" class="fa fa-times hover-effects"></span>
</div>